import React from "react";
import './Popup.css';
import { MdClose } from "react-icons/md";
import styled from "styled-components";

function Popup(props) {
  const CloseModalButton = styled(MdClose)`
    color: white;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    //padding: 0;
    // z-index: 10;
    //top: 16px;
  `;

  return props.trigger ? (
    <div className="popup">
      <div className="popup-inner">
        <CloseModalButton
          id='closebtn'
          aria-label="Close modal"
          onClick={() =>{
            props.setTrigger(false);
          } }
        />
        {props.children}
      </div>
    </div>
  ) : (
    ""
  );
 
}

export default Popup;
